import React from "react";

const ITEMS = [
  "OFC SPLICING",
  "OTDR TESTING",
  "FLUKE CERTIFICATION",
  "RACK DRESSING",
  "FTTH",
  "LAYER 2/3 CONFIG",
  "CCTV & SOLAR CCTV",
  "BIOMETRIC ACCESS",
  "WI-FI HEATMAP",
  "PERFORMANCE MONITORING",
  "NETWORK HEALTH CHECKUP",
  "ELECTRICAL PANEL",
];

const Marquee = () => {
  return (
    <div data-testid="marquee" className="relative border-y border-white/8 bg-[#0B1320]/60 overflow-hidden py-5">
      <div className="flex marquee-track gap-12 whitespace-nowrap">
        {[...ITEMS, ...ITEMS].map((item, i) => (
          <div key={i} className="flex items-center gap-4 font-mono text-xs uppercase tracking-[0.25em] text-[#A0B2C6]">
            <span className="text-[#FF6B00]">◆</span>
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
